export const EXTRA_KEY_FOB = [
  {
    key: "Asset",
    value: "keyfob",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "60px",
  },

  {
    key: "Hardware Status",
    value: "status",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "120px",
  },
  {
    key: "Quantity",
    value: "quantity",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "70px",
  },
  {
    key: "Category",
    value: "type",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "90px",
  },
  {
    key: "Subscription",
    value: "subscriptionName",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "200px",
  },
  {
    key: "Tech Ref Id",
    value: "techRefId",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "140px",
  },
  {
    key: "Type",
    value: "ticketType",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "60px",
  },
  {
    key: "Hardware",
    value: "hardwareTitle",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "160px",
  },
  {
    key: "Work Ticket",
    value: "workticketId",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "110px",
    template: "workTicketStatusTemplate",
  },
  {
    key: "Delivery Status",
    value: "deliveryStatus",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "120px",
  },
];
